import { render } from "./ lawyerRequested.vue?vue&type=template&id=308595ca"
import script from "./ lawyerRequested.vue?vue&type=script&lang=js"
export * from "./ lawyerRequested.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__